<!--  -->
<template>
  <div class="fxqy">
      <div class="head">风险区域</div>
      <div class="content">
          <div class="item" style="width:29%">
              <div style="margin-left:10px;margin-top:5px">变化时间</div>
              <div style="margin-left:10px;margin-top:15px">3.25 17:35</div>
          </div>
          <div class="item" style="width:35%">
              <div style="margin-top:5px;text-align: center;">变化原因</div>
              <div style="margin-top:15px;text-align: center;color:#d11717;">堵塞加剧</div>
          </div>
          <div class="item" style="display:flex;align-items: center;">
              <div class="btn">场景再现</div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.fxqy {
  width: 316px;
  height: 124px;
  position: absolute;
  top: 10vh;
  left: 10vw;
  background: url("../assets/tc.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .head{
      height: 36%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 12px;
  }
  .content{
      display: flex;
      height: 47%;
      margin-left: 10%;
      .item{
          font-size: 12px;
          color: #fff;
          width: 32%;
          .btn{
              width: 64px;
              height: 21px;
              background: url(../assets/btn2.png);
              background-repeat: no-repeat;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 16px;
          }
      }
  }
}
</style>